// extracted by mini-css-extract-plugin
module.exports = {"root":"reassurance_root__1d7LP","oldCompanies":"reassurance_oldCompanies__2vGTA","list":"reassurance_list__n1viG","text":"reassurance_text__OeCxE"};